import { render, staticRenderFns } from "./barcodeBindList.vue?vue&type=template&id=a6b2a4de&scoped=true&"
import script from "./barcodeBindList.vue?vue&type=script&lang=js&"
export * from "./barcodeBindList.vue?vue&type=script&lang=js&"
import style0 from "./barcodeBindList.vue?vue&type=style&index=0&id=a6b2a4de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b2a4de",
  null
  
)

export default component.exports